import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  GetCaseAlertsQuery,
  GetCaseAlertsQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { alertSummaryFragment } from "src/graphql/anti-fraud/fragments/AlertSummaryFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToAlertSummary } from "src/mappers/alert.mappers";

export const getCaseAlertsQuery = gql`
  query GetCaseAlerts($id: ID!) {
    case(id: $id) {
      id
      alerts {
        ...AlertSummaryFragment
      }
    }
  }

  ${alertSummaryFragment}
` as TypedDocumentNode<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>;

export const useGetCaseAlerts = (
  options?: QueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>
) => {
  return useFetchQuery(getCaseAlertsQuery, {
    queryOptions: options,
    toData: (data) => data?.case?.alerts?.map(mapToAlertSummary),
    isEmpty: (data) => data?.case?.alerts?.length === 0,
    uiErrors: {
      fetchError: "FETCH-ALERTS-ERROR",
      emptyError: "FETCH-ALERTS-ERROR",
    },
  });
};
